import { MediumBadge, StatusBadge } from '../common/Badge';
import type { Visit } from '../../types';

interface VisitRowProps {
  visit: Visit;
  index: number;
  onClick: () => void;
  timeWidth?: string;
  timeCol?: React.ReactNode;
  showStatus?: boolean;
}

export function VisitRow({ visit, index, onClick, timeWidth = '120px', timeCol, showStatus }: VisitRowProps) {
  const medium = visit.medium || 'video';

  let timeContent: React.ReactNode = timeCol;
  if (!timeContent) {
    if (!visit.isScheduled && !visit.scheduledAt) {
      timeContent = <span style={{ color: 'var(--accent-color)', fontWeight: 600 }}>Now</span>;
    } else {
      const ts = visit.scheduledAt || visit.createdAt;
      if (ts) {
        const d = new Date(ts);
        timeContent = `${d.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
      }
    }
  }

  return (
    <div
      className="today-schedule__row"
      data-index={index}
      role="button"
      tabIndex={0}
      style={{ cursor: 'pointer' }}
      onClick={onClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } }}
    >
      <div className="today-schedule__time" style={{ width: timeWidth, flexShrink: 0, paddingLeft: '0.5rem' }}>{timeContent}</div>
      <div style={{ width: '55px', flexShrink: 0 }}><MediumBadge medium={medium} /></div>
      <div style={{ flex: 1, fontWeight: 600, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {visit.patientName || 'Visit'}
      </div>
      {showStatus && visit.status && (
        <div style={{ flexShrink: 0 }}><StatusBadge status={visit.status} /></div>
      )}
      {visit.visitType && (
        <div className="text-sm text-muted" style={{ flexShrink: 0, marginLeft: showStatus && visit.status ? '0.5rem' : undefined }}>
          {visit.visitType}
        </div>
      )}
      <div style={{ flexShrink: 0, color: 'var(--border-color)', fontSize: '0.625rem', paddingRight: '0.5rem' }}>&#9654;</div>
    </div>
  );
}
